import React, { useEffect, useState } from "react";
import {
  MEDICATION_ROUTES,
  DOSE_UNITS,
  FREQUENCIES,
  DURATION_UNITS,
} from "../data/directionForm";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { MdZoomOut } from "react-icons/md";

const OptionComp = ({ options, value, setValue, label }) => {
  const handleChange = (e) => {
    const selected = e.target.selectedOptions[0];
    setValue(selected.dataset.label || "");
  };

  return (
    <Form.Group>
      <Form.Control
        as="select"
        value={options.find((o) => o.label === value)?.value || ""}
        onChange={handleChange}
        className={`custom-select text-center ${
          value ? "border border-primary" : "border border-danger"
        } `}
      >
        <option value="" disabled>
          {label}
        </option>
        {options.map((o) => (
          <option key={o.value} value={o.value} data-label={o.label}>
            {o.label}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  );
};

export default function MedicationDirectionForm({
  setDirection,
  show,
  setShow,
  direction,
  medication,
}) {
  const [route, setRoute] = useState("");
  const [doseUnit, setDoseUnit] = useState("");
  const [doseAmount, setDoseAmount] = useState("");
  const [frequency, setFrequency] = useState("");
  const [duration, setDuration] = useState("");
  const [durationUnit, setDurationUnit] = useState("");
  const [preparedDirection, setPreparedDirection] = useState("");

  const handleClose = () => {
    setShow(false);
    setDirection(preparedDirection);
  };

  useEffect(() => {
    const text = [
      route,
      doseAmount,
      doseUnit,
      frequency,
      duration ? `لمدة ${duration}` : "",
      durationUnit,
    ]
      .filter(Boolean)
      .join(" ");

    setPreparedDirection(text);
  }, [route, doseAmount, doseUnit, frequency, duration, durationUnit]);

  return (
    <Modal size="lg" show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center p-2 text-primary">
          {medication?.tradeLabel}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form className="p-3">
          <Row className="flex-row-reverse">
            <Col xs={12}>
              <OptionComp
                options={MEDICATION_ROUTES}
                value={route}
                setValue={setRoute}
                label="Define Route"
              />
            </Col>

            <Col md={4}>
              <Form.Control
                type="number"
                placeholder="Dose amount"
                className="text-center"
                value={doseAmount}
                onChange={(e) => setDoseAmount(e.target.value)}
                className={
                  !doseAmount || Number(doseAmount) === 0
                    ? "border-danger"
                    : "border-primary"
                }
              />
            </Col>

            <Col md={8}>
              <OptionComp
                options={DOSE_UNITS}
                value={doseUnit}
                setValue={setDoseUnit}
                label="Dose Unit"
              />
            </Col>

            <Col xs={12}>
              <OptionComp
                options={FREQUENCIES}
                value={frequency}
                setValue={setFrequency}
                label="Frequency"
              />
            </Col>

            <Col md={4}>
              <Form.Control
                type="number"
                placeholder="Duration"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                className={
                  !duration || Number(duration) === 0
                    ? "border-danger text-center"
                    : "border-primary text-center"
                }
              />
            </Col>

            <Col md={8}>
              <OptionComp
                options={DURATION_UNITS}
                value={durationUnit}
                setValue={setDurationUnit}
                label="Duration Unit"
              />
            </Col>
          </Row>

          <hr style={{ borderTop: "2px solid #4a90e2" }} />

          <Form.Group>
            <Form.Label>Direction</Form.Label>
            <Form.Control
              type="text"
              value={preparedDirection}
              onChange={(e) => setPreparedDirection(e.target.value)}
            />
          </Form.Group>

          <div className="d-flex justify-content-between">
            <Button onClick={() => handleClose()}>
              <MdZoomOut size={22} /> Save{" "}
            </Button>
            <Button
              variant="secondary"
              onClick={() => setShow(false)}
              className="mr-2"
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
